var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-sales',{attrs:{"enum-interface-type-derived":_vm.EnumInterfaceTypeDerived,"sales-data":_vm.salesData,"dates":_vm.dates,"interface-column-name":"interfaceTypeDerived","interface-selector":""},on:{"update:dates":function($event){_vm.dates=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }